<template>
  <Modal ref="modal" v-bind="{ redirectOnClose: true }">
    <div class="modal color-red max-w-md mx-auto" slot-scope="{ closeModal }" @click.stop>
      <div class="modal__header">
        <h6 class="heading">
          {{ $t('deleteCreative') | capitalize }}
        </h6>
      </div>
      <div class="modal__body space-y-8">
        <p class="text-center">
          {{ $t('deleteConfirmation') | capitalize }}
        </p>
        <div class="space-x-2 text-right">
          <button
            type="button"
            :disabled="deleting"
            class="btn style-link px-6"
            @click="closeModal"
          >
            {{ $t('cancel') | capitalize }}
          </button>
          <button :disabled="deleting" class="btn btn-danger px-6" @click="destroy">
            {{ $t('delete') | capitalize }}
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mediaMethods } from '@/store/helper';
import Modal from '@/components/Ui/Modal.vue';

export default {
  name: 'ModalDelete',
  components: {
    Modal,
  },
  props: {
    mediaItemId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
  }),
  methods: {
    ...mediaMethods,
    destroy() {
      this.deleting = true;
      const { mediaItemId } = this;
      this.deleteMediaItem({ mediaItemId })
        .then(() => {
          this.deleting = false;
          this.$emit('deleted', mediaItemId);
          this.$refs.modal.closeModal();
        })
        .catch(() => {
          this.deleting = false;
        });
    },
  },
};
</script>
